<div class='terminal-card__icon'>
  <nb-icon
    *ngIf="terminalTypeIcon !== 'terminalType_0'"
    class='color-0-custom-icon__terminalType'
    icon='{{ terminalTypeIcon }}'
    nbPrefix
    pack='customIcons'
    status='control'
  ></nb-icon>
  <nb-icon
    *ngIf="terminalTypeIcon === 'terminalType_0'"
    class='color-0-custom-icon__terminalType small'
    icon='monitor-outline'
    nbPrefix
    pack='eva'
    status='control'
  ></nb-icon>
</div>
<div class='terminal-card__description'>
  <div class='terminal-title'>
    {{ summary.type.name }}
    <!--    don't show for now-->
    <!--    <span class='summary-total'>{{ summary.counts.total }}</span>-->
  </div>
  <div class='terminal-status'>
    <div *ngIf='summary.counts.offline > 0' class='pe-2 jee'>
      <app-terminal-name ledColor='red'
                         name="{{ summary.counts.offline }} {{ 'TERMINALS.WORD_OF' | translate }}
                      {{ summary.counts.total }} {{ 'TERMINALS.OFFLINE' | translate | lowercase }}">
      </app-terminal-name>
    </div>
    <div *ngIf='summary.counts.offline === 0 && summary.counts.inUse' class='pe-2 jee'>
      <app-terminal-name ledColor='green'
                         name="{{ summary.counts.inUse }} {{ 'TERMINALS.WORD_OF' | translate }}
                      {{ summary.counts.total }} {{ 'TERMINALS.ONLINE' | translate | lowercase }}">
      </app-terminal-name>
    </div>
    <div *ngIf='summary.counts.outOfUse >= 1' class='jee'>
      <app-terminal-name ledColor='grey'
                         name="{{ summary.counts.outOfUse }} {{ 'TERMINALS.OUT_OF_USE' | translate }}">
      </app-terminal-name>
    </div>
  </div>
</div>
